import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Paper,
  TableContainer,
  Typography,
} from "@mui/material";
import PageTitle from "../../../Reuse/UI/PageTitle";
import { usePaginationCore } from "../../../hooks";
import { CheckValue } from "../../../Service/service";
import { defaultFilter, ListContextProvider } from "./Context";
import Card from "./Card";
import List from "./List";
import { useNavigate, useSearchParams } from "react-router";
import { getCampusList } from "../../../Service/Api/campus";

const Campuses = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isList, setIsList] = useState(() => {
    const view = searchParams.get("view");
    if (CheckValue(view) && (view === "list" || view === "card")) {
      return view === "list";
    }
    return false;
  });

  const {
    data: row,
    count,
    paginationUI,
  } = usePaginationCore({
    pageName: "Campus",
    fetchFn: getCampusList,
    deleteFn: null,
    defaultFilter,
    enablePagination: true,
  });

  useEffect(() => {
    const scroll = () => {
      const doc = document.getElementById("containerId");
      doc?.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    };

    const toggleView = (isList) => {
      const newParams = new URLSearchParams(searchParams.toString());
      newParams.set("view", isList ? "list" : "card");
      setSearchParams(newParams);
    };

    toggleView(isList);
    scroll();
  }, [isList, searchParams, setSearchParams]);

  const value = useMemo(
    () => ({
      isList,
      setIsList,
    }),
    [isList]
  );

  const addButtonClick = useCallback(
    (e) => {
      if (CheckValue(e)) {
        e.preventDefault();
      }
      navigate("./add");
    },
    [navigate]
  );

  return (
    <React.Fragment>
      <ListContextProvider value={value}>
        <PageTitle
          title={"Campuses"}
          count={count}
          isFilter={true}
          isAction={true}
          isUIFilter={true}
          isWrap={true}
          searchPlaceHolder={"Search by campus name or number"}
          defaultFilter={defaultFilter}
          addButtonText={"Add New Campus"}
          addButtonClick={addButtonClick}
        />
        <TableContainer
          id={"containerId"}
          component={Paper}
          elevation={0}
          sx={{
            borderRadius: 0,
            flexGrow: 1,
            background: "transparent",
            // marginBottom: 4.5,
          }}
        >
          {isList ? <List rows={row} /> : <Card rows={row} />}
          {!row.length && <Typography variant="noData">{"No data"}</Typography>}
        </TableContainer>
        {paginationUI}
      </ListContextProvider>
    </React.Fragment>
  );
};

export default Campuses;
